export default __webpack_public_path__ + "static/media/pyup.5679055e.svg";